import { pluralize } from "@/lib/utils";

window.pluralize = pluralize;
